import { render, staticRenderFns } from "./f-edit.vue?vue&type=template&id=0cca825c&scoped=true&"
import script from "./f-edit.vue?vue&type=script&lang=js&"
export * from "./f-edit.vue?vue&type=script&lang=js&"
import style0 from "./f-edit.vue?vue&type=style&index=0&id=0cca825c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cca825c",
  null
  
)

export default component.exports